// assets
import entitlementIcon from '../assets/images/icons/entitlement.svg';

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const entitlementManagement = {
  id: 'entitlement_management',
  title: '',
  type: 'group',
  children: [
    {
      id: 'entitlement_management',
      title: 'Entitlement Management',
      type: 'collapse',
      icon: entitlementIcon,
      children: [
        {
          id: 'Contracts',
          title: 'Contracts',
          type: 'item',
          url: '/entitlement/Contracts',
          breadcrumbs: false,
          featureName: 'ContractManagement',
        },
        {
          id: 'Customers',
          title: 'Customers',
          type: 'item',
          url: '/entitlement/Customers',
          breadcrumbs: false,
          featureName: 'ContractManagement',
        },
        {
          id: 'Entitlements',
          title: 'Entitlements',
          type: 'item',
          url: '/entitlement/Entitlements',
          breadcrumbs: false,
          featureName: 'EntitlementManagement',
        },
        {
          id: 'ErpSalesOrder',
          title: 'ERP Sales Order',
          type: 'item',
          url: '/entitlement/ErpSalesOrder',
          breadcrumbs: false,
          featureName: 'ContractManagement',
        },
        {
          id: "Sites",
          title: "Sites",
          type: "item",
          url: "/entitlement/Sites",
          breadcrumbs: false,
          featureName: 'ContractManagement',
        },
        {
          id: "OutOfScopeCases",
          title: "Out of Scope Cases",
          type: "item",
          url: "/entitlement/OutOfScopeCases",
          breadcrumbs: false,
          featureName: 'OOS',
        },
        {
          id: 'ERPSalesOrderItems',
          title: 'ERP Sales Order Items',
          type: 'item',
          url: '/entitlement/ERPSalesOrderItems',
          breadcrumbs: false,
          featureName: 'ContractManagement',
        },
      ],
    },
  ],
};

export default entitlementManagement;
